import { render } from "./SkeletonList.vue?vue&type=template&id=08e0c796"
const script = {}
script.render = render

export default script